// extracted by mini-css-extract-plugin
export default {"sizer":"GrowingTextArea_sizer__OB5Qi"};